/*
 * File: /src/store/modules/leadSource.js
 * Created Date: Tuesday December 14th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:46:13 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import LeadSourceService from 'src/services/leadSourceService';
import LeadSourceDetailService from 'src/services/leadSourceDetailService';

const state = {
  leadSources: undefined,
  leadSourceDetails: undefined,
};

const getters = {
  getLeadSources: state => state.leadSources,
  getLeadSourceDetails: state => leadSourceId => state.leadSourceDetails ? state.leadSourceDetails.filter(lsd => lsd.lead_source_id == leadSourceId) : [],
  getHasLeadSourceDetails: states => state.leadSourceDetails.length ? true : false,
};
const actions = {
  async fetchLeadSources({ commit, state }) {
    // Only load the data once
    if (state.leadSources == undefined) {
      return LeadSourceService.fetchAll()
        .then(r => {
          commit('setLeadSources', r.data);
        });
    }
  },
  async fetchLeadSourceDetails({ commit, state }) {
    // Only load the data once
    if (state.leadSourceDetails == undefined) {
      return LeadSourceDetailService.fetchAll()
        .then(r => {
          commit('setLeadSourceDetails', r.data);
        });
    }
  },
  unloadLeadSources({ commit }) {
    commit('setLeadSources', undefined);
  },
  unloadLeadSourceDetails({ commit }) {
    commit('setLeadSourceDetails', undefined);
  },
};
const mutations = {
  setLeadSources(state, Sources) {
    state.leadSources = Sources;
  },
  setLeadSourceDetails(state, Details) {
    state.leadSourceDetails = Details;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
